import React from "react";
import "./Header.css";
import CallOutlinedIcon from "@mui/icons-material/CallOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import { Typography } from "@mui/material";
import logoSvg from "../../Assests/Images/logo.svg";

export default function Header() {
  return (
    <header className="header">
      <div className="header-container">
        {/* Logo Section */}
        <div className="header-logo">
          <img src={logoSvg} alt="SaafSafaiWale" className="logo-img" />
          <span className="logo-text">SaafSafaiWale</span>
        </div>

        {/* Contact Info */}
        <div className="header-contact hide-on-mobile">
          {/* Phone */}
          <div className="contact-item">
            <CallOutlinedIcon className="contact-icon" />
            <div className="contact-info">
              <Typography className="contact-title">Phone</Typography>
              <Typography>
                <a href="tel:+91-9953614486" className="contact-link">
                  +91&nbsp;99536&nbsp;14486
                </a>
              </Typography>
            </div>
          </div>

          {/* Email */}
          <div className="contact-item">
            <EmailOutlinedIcon className="contact-icon" />
            <div className="contact-info">
              <Typography className="contact-title">E-mail</Typography>
              <Typography>
                <a href="mailto:Saafsafai53@gmail.com" className="contact-link">
                 Saafsafai53@gmail.com
                </a>
              </Typography>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
